import React, { FC, useContext, useEffect, useState } from 'react'
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { GlobalContext } from '../../../../context/GlobalContext';


const { TextArea }: any = Input;

interface CommentFieldProps {
    onChangeComment: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    value?: string;
    maxLength?: number;
}
const CommentField: React.FC<CommentFieldProps> = ({ onChangeComment, value, maxLength = 500 }) => {
    const [state]: any = useContext(GlobalContext);
    const { rtl } = state;
    const { t } = useTranslation();
    const dir = rtl ? "right" : "left";
    const [letterCount, setLetterCount] = useState<number>(0);
    useEffect(() => {
        const commentValue = typeof value === 'string' ? value : '';
        const lettersOnly = commentValue.match(/[A-Za-z\u0600-\u06FF\u0400-\u04FF]/g) || [];
        setLetterCount(lettersOnly.length);
    }, [value])

    return (

        <div className={`download-upload-section`}>
            <div className={`comment_header ${dir}`}>
                {t("Comment")}
            </div>
            <Form.Item
                name="comment"
                rules={[{ required: false }]}
            >
                <TextArea rows={4} maxLength={maxLength} onChange={onChangeComment} value={value} />
                <div className="comment-length-counter">
                    {letterCount} {t('letters')} / {maxLength} {t('max')}
                </div>

            </Form.Item>
        </div>

    )

}

export default CommentField
